"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.permillToFixedU128 = void 0;

var _bn = _interopRequireDefault(require("bn.js"));

const permillToFixedU128 = permill => {
  return permill.mul(new _bn.default(10 ** (18 - 6)));
};

exports.permillToFixedU128 = permillToFixedU128;